import config from '../../config';
import store from '../store';
import APIService from './APIService';
const baseUrl = config.baseUrlForNotificationTemplateService;
export default class NotificationTemplateService extends APIService {
  // It will get all the templates from current Org
  // If there is not templates for current Org, It
  // will get all templates of xift.
  static getAllOrgTemplates() {
    return this.get(`${baseUrl}/templates?type=EMAIL`);
  }

  /**
   * @param {string} templateName
   * @param {object} bodyData
   * {
   * "details": "string",
   * "notificationChannel": @enum SMS, EMAIL
   * "orgId": "string",
   * "rawMessage": "string",
   * "title": "string"
   * }
   */
  static createTemplateDefinition({ templateName, bodyData }) {
    return this.post(
      `${baseUrl}/template/${templateName}/template-definition`,
      bodyData
    );
  }

  /**
   * @param {string} templateId
   * @param {object} bodyData
   * {
   * "details": "string",
   * "notificationChannel": @enum SMS, EMAIL
   * "rawMessage": "string",
   * "title": "string"
   * }
   */
  static updateTemplateDefinition({ templateId, bodyData }) {
    return this.put(`${baseUrl}/template-definition/${templateId}`, bodyData);
  }

  /**
   * @param {string} templateId
   * @param {string} channelName
   */
  static getTemplateDefinition({ templateId, channelName, orgID }) {
    let orgId = orgID ? orgID : store.state.currentlySelectedOrgId;
    return this.get(
      `${baseUrl}/template/${templateId}/template-definition/${channelName}?currentOrg=${orgId}`
    );
  }
}
